// Redirige vers la page de confirmation après l'envoi réussi d'un
// formulaire Contact Form 7, au lieu d'afficher le message de succès inline.
document.addEventListener('wpcf7mailsent', function (event) {
  window.location.href = '/confirmation';
}, false);
